export default __webpack_public_path__ + "static/aws_partner_network_training-3eb24e3cc5a377e8149d19c46b2d762f.png";